import elementResizeDetectorMaker from 'element-resize-detector';
export default (function () {
  var resizerIns = elementResizeDetectorMaker({
    strategy: 'scroll',
    callOnAdd: true
  });
  var getRaf = function getRaf() {
    var w = window;
    return w.requestAnimationFrame || w.webkitRequestAnimationFrame || w.mozRequestAnimationFrame || w.oRequestAnimationFrame || w.msRequestAnimationFrame || function (callback) {
      w.setTimeout(callback, 1000 / 60);
    };
  };
  resizerIns.debncListenTo = function (el, callback) {
    return resizerIns.listenTo(el, function (func, wait) {
      var timeout;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var later = function later() {
          clearTimeout(timeout);
          getRaf()(function () {
            return func.apply(void 0, args);
          });
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }(callback, 10));
  };
  return resizerIns;
});